import { useEffect, useState } from "react";
import type { Session } from "@supabase/supabase-js";
import { supabase } from "@/lib/supabase";
import type { PortalGrantRow } from "@/types/portalUser";

export type PortalSessionPayload = {
  email: string;
  grants: PortalGrantRow[];
};

export function usePortalUser(session: Session | null) {
  const [portalSession, setPortalSession] = useState<PortalSessionPayload | null>(null);
  const [checking, setChecking] = useState(!!session);

  useEffect(() => {
    if (!session?.user?.email) {
      setPortalSession(null);
      setChecking(false);
      return;
    }
    const normalizedEmail = session.user.email.trim().toLowerCase();
    let cancelled = false;
    setChecking(true);
    void supabase
      .from("portal_access_grants")
      .select("id,email,capability,branch_id,batch_id,association_id,created_at")
      .eq("email", normalizedEmail)
      .order("created_at", { ascending: true })
      .then(({ data, error }) => {
        if (cancelled) return;
        if (error) {
          console.error(error);
          setPortalSession(null);
        } else {
          const grants = (data as PortalGrantRow[]) ?? [];
          setPortalSession(
            grants.length ? { email: normalizedEmail, grants } : null
          );
        }
        setChecking(false);
      });
    return () => {
      cancelled = true;
    };
  }, [session?.user?.email]);

  return {
    portalSession,
    checking,
    isPortalUser: !!portalSession?.grants.length,
  };
}
